import styled, { css } from "styled-components";

import themeColors from "styles/config/colors";
import sizes from "styles/config/sizes";
import themeSpacing from "styles/config/spacing";

type LoaderProps = {
  $spinner: boolean;
  $logo: boolean;
  $fullScreen: boolean;
  $inProjectPage: boolean;
};

export const Loader = styled.div<LoaderProps>`
  ${(props) =>
    props.$spinner &&
    css`
      display: flex;
      flex-direction: column;
      gap: ${themeSpacing.sm2};
      align-items: center;
      justify-content: center;

      svg {
        transform-origin: top;
        transform: scale(2);
        color: ${themeColors.iconPrimaryBrand};

        & > g {
          transform-origin: 50% 50% !important;
          transform-box: view-box !important;
        }
      }
    `}

  ${(props) =>
    props.$logo &&
    css`
      display: flex;
      flex-direction: column;
      gap: ${themeSpacing.sm1};
      align-items: center;
      justify-content: center;

      svg {
        transform: translateX(-${themeSpacing.xxs2});
        width: ${sizes.loadingAnimation}px;
        height: ${sizes.loadingAnimation}px;
      }
    `}

  ${(props) =>
    props.$fullScreen &&
    props.$inProjectPage &&
    css`
      width: 100%;
      height: 70vh;
    `}
  
  ${(props) =>
    props.$fullScreen &&
    !props.$inProjectPage &&
    css`
      width: 100%;
      height: 100vh;
    `}
`;
